/*
 * Copyright (c) 2017, Indigen Solutions. All rights reserved.
 *
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 *
 * This software is the confidential and proprietary information.
 *
 * You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement
 * you entered into.
 */
import { combineReducers } from "redux";

import { RootState } from "../../types/RootState";
import meReducer from "./me.reducer";
import authReducer from "./auth.reducer";
import notificationReducer from "./notification.reducer";
import contextReducer from "./context.reducer";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const authPersistConfig = {
    key: "auth",
    storage,
};
const mePersistConfig = {
    key: "me",
    storage,
};

export const rootReducer = combineReducers<RootState>({
    env: () => (window as any).process.env,
    auth: persistReducer(authPersistConfig, authReducer),
    me:  persistReducer(mePersistConfig, meReducer),
    notification: notificationReducer,
    context: contextReducer
});


// WEBPACK FOOTER //
// ./src/store/reducers/index.ts